













import BaseState from '@spa/components/pages/paid-membership/unsubscribe/confirm/state/BaseState.vue'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

/**
 * 今まで契約したことが無い場合
 */
@Component({
  components: { BaseState },
})
export default class NotEverSubscribed extends Vue {
}
